<template>
  <div>
    <!-- <Header /> -->
    <div
      class="container mx-auto max-w-[1200px] w-full py-3 flex flex-col gap-10 px-4 md:px-6 xl:px-0 lg:gap-2"
    >
      <div class="flex justify-end">
        <router-link
          :to="{ name: 'PreviewStudentHome' }"
          class="bg-blues hover:bg-hover text-white rounded-lg text-sm font-semibold px-5 py-1"
          >Back</router-link
        >
      </div>
      <SyallbusView />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import SyallbusView from "@/components/Student_preview/SyallbusView.vue";

import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    SyallbusView,
  },
  // computed: mapGetters(["userInfo"]),
};
</script>

<style></style>
